import React from 'react';

const Topbar: React.FC = () => {
    const logo = "assets/layout/images/pokedex.png"
    return (
        <div className="topbar">
            {/* <h1 className='title-topbar'>Github Users Api</h1> */}
            <img alt='pokedex' src={logo} style={{ height: '6rem' }} />
        </div>
    );
}

export default Topbar;